// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'; import './autoload/_fontawesome.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import templateResourceDatabase from './routes/template-resource-database';
import templateOpportunityDatabase from './routes/template-opportunity-database';
import templateResourceDatabaseClassic from './routes/template-resource-database-classic';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  templateResourceDatabase,
  templateOpportunityDatabase,
  templateResourceDatabaseClassic,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js